// extracted by mini-css-extract-plugin
export default {"root":"_2GDRu","avatar":"_1u2vN"};